module.exports = "<div class=\"container\">\n    <span class=\"thinking\">{{ 'ai_thinking' | translate }}</span>\n    <div class=\"dots\">\n        <i></i>\n        <i></i>\n        <i></i>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/ai-chat/components/ai-thinking/ai-thinking.component.html
// module id = ../../../../../src/app/ai-chat/components/ai-thinking/ai-thinking.component.html
// module chunks = main